
import { ApiConfig } from '../constants/apiConfig';
import axios from 'axios';
import { studentHeaders } from './apiClient';

export async function fetchJadwalHariIni(siswaId) {
  try {
    const response = await axios.get(`${ApiConfig.baseUrl}/jadwals?siswa_id=${siswaId}`, {
      headers: {
        ...studentHeaders(),
        Accept: 'application/json',
      },
    });

    const data = response.data;
    if (response.status === 200 && data.success) {
      return data.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching jadwal:", error);
    return null;
  }
}

export async function fetchSemuaJadwal(siswaId) {
  try {
    const response = await axios.get(`${ApiConfig.baseUrl}/jadwals/all?siswa_id=${siswaId}`, {
      headers: {
        ...studentHeaders(),
        Accept: 'application/json',
      },
    });

    const data = response.data;
    return response.status === 200 && data.success ? data.data || [] : [];
  } catch (error) {
    console.error('Error fetching semua jadwal:', error);
    throw new Error(error.response?.data?.message || 'Jadwal belum bisa dimuat.');
  }
}

export async function simpanJadwal(jadwal, id = null) {
  const url = id
    ? `${ApiConfig.baseUrl}/jadwals/${id}`
    : `${ApiConfig.baseUrl}/jadwals`;
  const response = await axios({
    method: id ? 'put' : 'post',
    url,
    data: jadwal,
    headers: studentHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }),
  });

  return response.data;
}
